import React from "react";
const GradientIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "40px", height: "40px", viewBox: "0 0 40 40", ...props }, /* @__PURE__ */ React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-143.000000, -242.000000)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(143.000000, 242.000000)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { stroke: "currentColor", x: "0.5", y: "0.5", width: "39", height: "39", rx: "1" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", { transform: "translate(0.726273, 1.000000)" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    stroke: "currentColor",
    strokeWidth: "1",
    d: "M38.7737269,-1.20727103 L-1.20694257,38.7810917 L38.7737269,38.7810917 L38.7737269,-1.20727103 Z"
  }
)))))))));
export {
  GradientIcon
};
//# sourceMappingURL=GradientIcon.js.map
